import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { Banner } from "@obg/ngx.common";
import { coerceBoolean } from "@obg/ngx.global.evo";

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: "article[obg-common-banner-slide]",
	templateUrl: "./banner-slide.component.html",
	styleUrls: ["./banner-slide.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CommonBannerSlideComponent {
	@HostBinding("class.obg-common-banner-slide") hostCssClass = true;

	@Input() banner: Banner | undefined;

	@Input() maxWidth: string | undefined;

	@HostBinding("class.minimized")
	@Input()
	@coerceBoolean()
	minimized = false;

	@Input()
	@coerceBoolean()
	showTermsTitle = false;

	getUrl() {
		return this.banner?.button?.url ?? this.banner?.url;
	}

	get verifiedBanner(): boolean {
		if (this.banner && this.banner.termsAndConditionsApply && this.banner.termsAndConditionsDescription) {
			return true;
		}
		return false;
	}
}
